import { ReactNode } from 'react';

import { CardId } from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';

export const CARD_VARIANT_THEME_KEYS = {
  ACTIVE_LIGHT_TOP: 'ACTIVE_LIGHT_TOP',
  INACTIVE_LIGHT_TOP: 'INACTIVE_LIGHT_TOP',
  ACTIVE_LIGHT_PREMIUM: 'ACTIVE_LIGHT_PREMIUM',
  INACTIVE_LIGHT_PREMIUM: 'INACTIVE_LIGHT_PREMIUM',
  ACTIVE_DARK_TOP: 'ACTIVE_DARK_TOP',
  INACTIVE_DARK_TOP: 'INACTIVE_DARK_TOP',
  ACTIVE_DARK_PREMIUM: 'ACTIVE_DARK_PREMIUM',
  INACTIVE_DARK_PREMIUM: 'INACTIVE_DARK_PREMIUM'
} as const;

export type CardVariantThemeKey = keyof typeof CARD_VARIANT_THEME_KEYS;

export type OptionCardStyle = {
  background: string;
  borderColor: string;
  iconBackground?: string;
};

export type ContentOption = {
  id: number;
  title: string;
  description: string;
};

export type OptionItem = {
  id: CardId;
  icon: ReactNode;
  title: string;
  subtitle: string;
};

export type ContentOptions = ContentOption[];

export enum PaymentTypeEnum {
  ADVERTISE = 'ADVERTISE',
  PUBLICATION = 'PUBLICATION'
}
